import React from "react";

import {
  VerificationSummary as VerificationSummaryType,
} from "./dashboardType"

interface Props {
  data: VerificationSummaryType;
}

const VerificationSummary: React.FC<Props> = ({
  data,
}) => {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Verification
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div>
          <p className="text-sm text-gray-500">
            Total
          </p>
          <p className="text-xl font-bold">
            {data.Total}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Pending
          </p>
          <p className="text-xl font-bold">
            {data.Pending}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Verified
          </p>
          <p className="text-xl font-bold">
            {data.Verified}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">
            Verification Rate
          </p>
          <p className="text-xl font-bold">
            {data.Verification_Rate}%
          </p>
        </div>
      </div>
    </section>
  );
};

export default VerificationSummary;